import { VENUES_CONSTANTS } from 'AppConstants';
import { logOmniClick } from 'omnitures';
import { setPathValueInObj } from './Util';

export const formatQueryForm = (fields = []) => {
	let retData = {};
	fields.forEach((field) => {
		let value = field.type === 'select' ? field.value.value : field.value; ;
		if (field.formatSave) {
			value = field.formatSave(value);
		}
		retData = setPathValueInObj(retData, field.name, value);
	});
	return retData;
};

export const trackClick = (prop) => {
	const pageName = 'MICE_page:MICE_funnel|corporate';
	logOmniClick(VENUES_CONSTANTS.CLICKEVT, {
		prop54: prop,
		pageName
	});
};
